<template>
    <v-menu
        v-model="menu_time_picker"
        :close-on-content-click="false"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
    >
        <template slot="activator">
            <v-text-field
                v-focus="focus ? focus : false"
                v-model="current_value"
                v-bind="$attrs"
                v-on="$listeners"
                :label="$attrs.label ? $attrs.label : $t('lang.time')"
                append-icon="access_time"
                :class="inputClass"
                readonly
                :prepend-icon="$attrs['prepend-icon'] ? $attrs['prepend-icon'] : ''"
                :prepend-inner-icon="$attrs['prepend-inner-icon'] ? $attrs['prepend-inner-icon'] : ''"
                :append-outer-icon="$attrs['append-outer-icon'] ? $attrs['append-outer-icon'] : ''"
            ></v-text-field>
        </template>
        <v-time-picker
            v-model="current_value"
            format="24hr"
            full-width
            scrollable
            @change="update($event)"
        ></v-time-picker>
    </v-menu>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: ['focus', 'value', 'inputClass'],
    data() {
        return {
            menu_time_picker: false
        };
    },
    computed: {
        ...mapGetters([
            'localeCodes'
        ]),
        current_value: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        update($event){
            this.menu_time_picker = false;
            this.$emit('update', $event);
        }
    }
};
</script>